<template>
  <div class="login-page">
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <info-section
                class="mt-5"
                type="danger"
                title="Marketing"
                description="We've created the marketing campaign of the website. It was a very interesting collaboration."
                icon="nc-icon nc-alert-circle-i"
              >
                <h2 class="text-white mt-3">Page Not Found</h2>
                <small class="text-white">
                  Oops! It seems that this page does not exist.
                  <br />You can navigate back
                  <router-link to="/">to main page</router-link>
                </small>
              </info-section>
            </div>
          </div>
        </div>
        <div
          class="full-page-background"
          style="background-image: url(static/img/background/jan-sendereks.jpg) "
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import { Card, Button, InfoSection } from "src/components/Template";
export default {
  components: {
    Card,
    InfoSection,
    [Button.name]: Button
  },
  methods: {
  },
  beforeDestroy() {
  }
};
</script>
<style scoped></style>
